import { Component, OnInit } from '@angular/core';
import { VideoService } from '../video.service';
import { StarComponent } from '../star/star.component';

@Component({
  selector: 'video-app',
  templateUrl: './video-app.component.html',
  styleUrls: ['./video-app.component.css'],
  providers:[VideoService]
})
export class VideoAppComponent implements OnInit {
  starObject = {};
  constructor(private _videoService:VideoService) { }

  
  onStarsChanged($event){
    console.log("onStarsChanged ",$event)
  }

  ngOnInit() {
        //userID = $(document.getElementById("newUserID")).html();
        var userID = window['userID'];
        if(userID != null && userID != "AFTEST"){
          window['addAnalytics'](window['ga_id']);
          this._videoService.appSetup("videoDisplay");
          this.starObject = {
            totalStars: ["star1","star2","star3","star4","star5"],
            starLiked: "none"
          }
          this._videoService.gatherJSON(); // comment out if using hardcoded data, from ASP
        }else{
          //alert(userID);
          window['doNotDisplay']();
          
        }
        
        
  }

}



// WEBPACK FOOTER //
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/video-app/video-app.component.ts